module.exports = __webpack_public_path__ + "assets/img/27_1286_big.e83c6dc5.jpg";